<template>
  <div class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 pt-4">
    <pirate-card
      v-for="(pirate, index) in pirates"
      :pirate="pirate"
      @click="openPirateDrawer(pirate)"
    ></pirate-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { openBottomDrawer } from '@/composables/bottomdrawer'
import PirateCard from '../PirateCard.vue'
import PirateDrawer from '../drawers/PirateDrawer.vue'
import { useConstantStore } from '@/stores/constant'
import { useGameStore } from '@/stores/game'


const constantStore = useConstantStore()
const gameStore = useGameStore()

const pirates = constantStore.characters

const openPirateDrawer = (pirateInfo) => {
  openBottomDrawer(PirateDrawer, {
    props: { pirateInfo: pirateInfo },
    emits: {
      // close: () => fillCharacters(),
    },
    size: 'md',
  })
}
</script>
